module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAaCAYAAADi4p8jAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAOKADAAQAAAABAAAAGgAAAACVnjYNAAABC0lEQVRYCe2YMU7DMBSG/99ymHuE3KBXKCcgEgwMlegROrZdMBI7cIMMjAxwg3KDcpN0bdw8XopyAi/Gel4sS7H1f19kS+8xrJrZqa9eSGkAzlDEkA6Ctqrik+9735K4Ubgi0P4g9EcR61P0RwdS4UodXLhS0SYuB5GvaVHeLHunF3E1QorgWArgyCLA25WPr6UwGYcZMANmwAyYATNgBsyAGcjOwKWM3y5vG4Lz7NIlBNJC9/v5/WPP3fIuKNxjwlnZbiXkWgtePmSbMDHYAAanDac68Zyst489mZ+sEyaEo0jnBgyhpHbF5GNkOp/j+vKKbu6b2ntfD8Bi+uC/zhR0eu0O3sdDaD+7X1AER7eeKPNiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu.png
// module id = 01ru
// module chunks = 47